/**
 * Number-in-copy style: spell out small counts as words (0–9), use digits for
 * 10+. Keeps user-facing prose reading naturally ("Sequencing three days…")
 * while large counts stay compact. Used across loading/summary copy, the
 * Memories like-list, and expense-split notifications.
 *
 * NOT for compact UI chrome — the countdown hero number, expense metadata rows,
 * and avatar-overflow badges intentionally stay as digits.
 */
const ONES = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];

/** Spell out 0–9 as a lowercase word; 10+ (or non-finite) returns digits. */
export function numberWord(n: number): string {
  if (!Number.isFinite(n)) return String(n);
  const i = Math.trunc(n);
  return i >= 0 && i <= 9 ? ONES[i] : String(i);
}

/** Capitalized variant for the start of a sentence or label. */
export function numberWordCap(n: number): string {
  const w = numberWord(n);
  return w.charAt(0).toUpperCase() + w.slice(1);
}
